import { createRef } from "react"

const state = {
  scroll: createRef(),
}

export default state;